<script setup lang="ts">
import type {
  IFavoriteButtonProps,
  IFavoriteButtonEmits,
} from '@/features/FavoriteButton/model/types/favoriteButton';

import { ROLE_TYPE_USER } from '@/shared/constants/roleTypeConstants';
import { useModalStore } from '@/shared/ui/AppModal/store/modal';
import { useUserStore } from '@/entities/user/store';

const props = withDefaults(defineProps<IFavoriteButtonProps>(), {
  modelValue: false,
});

const emit = defineEmits<IFavoriteButtonEmits>();

const modalStore = useModalStore();
const userStore = useUserStore();

const isMobile: boolean = useIsMobile();
const { isAuth } = storeToRefs(userStore);

const clickHandler = (): void => {
  if (isAuth.value) {
    emit('update:modelValue', !props.modelValue);
    return;
  }

  modalStore.setModalState('auth', true, {
    isLogin: true,
    mode: ROLE_TYPE_USER,
  });
};
</script>

<template>
  <button
    :class="['favorite-button', { _active: modelValue, _mobile: isMobile }]"
    aria-label="Добавить в избранное"
    @click.prevent="clickHandler"
  >
    <AppIcon name="Favorite" />
  </button>
</template>

<style lang="less">
.favorite-button {
  display: inline-flex;
  justify-content: center;
  align-items: center;

  path {
    fill: white;
    stroke: @color-persimmon;
    transition: fill @A ease-in-out;
  }

  &:not(._mobile):hover path {
    fill: @color-persimmon;
  }

  &._active path {
    fill: @color-persimmon;
  }
}
</style>
